<template>
    <v-layout class="flex-column ">
        <v-row class="align-center justify-space-between px-3">
            <v-col cols="12"
                   lg="3"
                   md="3"
                   sm="6"
                   class="align-center px-0"
            >
                <DropDown
                        v-if="getClientsList.length"
                        class="theme--dark"
                        :items="getClientsList"
                        :itemText="'name'"
                        :itemValue="'id'"
                        v-on:onSelect="changeClient"
                        :openOnClick="openOnClick"
                        :editable="true"
                        :placeholder="'Select Client'"
                        :type="'client'"
                />
            </v-col>
            <v-col cols="12"
                   lg="6"
                   md="6"
            >
                <v-item-group mandatory @change="changeTab">
                    <v-container class="ma-0 pa-0 w-100">
                        <v-row class="justify-center">
                            <v-col
                                    v-for="(n, index) in tabs"
                                    :key="index"
                                    cols="12"
                                    lg="2"
                                    md="2"
                                    sm="4"
                                    class="pa-0"
                            >
                                <v-item v-slot="{ active, toggle }">
                                    <v-card
                                            :color="active ? 'primary' : '#f4f6f8'"
                                            class="d-flex align-center justify-center"
                                            height="42"
                                            dark
                                            flat
                                            outlined
                                            @click="toggle"
                                            style="border-radius: 0"
                                    >
                                        <v-scroll-y-transition>
                                            <div v-if="active" >{{n.name}}</div>
                                            <div v-if="!active" style="color: #411F90">{{n.name}}</div>
                                        </v-scroll-y-transition>
                                    </v-card>
                                </v-item>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-item-group>
            </v-col>
            <v-col cols="12"
                   lg="3"
                   md="3"
                   sm="6"
                   class="align-center px-0"
            >
            </v-col>
        </v-row>
        <BenchmarksByClient v-if="currentTab === 0"/>
    </v-layout>
</template>

<script>
    import BenchmarksByClient from "./BenchmarksByClient";
    import DropDown from "../../common/DropDown";
    import { createNamespacedHelpers} from "vuex";
    const authHelper = createNamespacedHelpers("auth");
    export default {
        name: "BenchmarksDashboard",
        components: { DropDown, BenchmarksByClient },
        data: () => ({
            openOnClick: false,
            currentTab: 0,
            tabs: [{id: 0, name: 'CLIENTS'}],
        }),
        computed: {
            ...authHelper.mapGetters(["getClientsList"])
        },
        methods: {
            ...authHelper.mapMutations(["SET_SELECTED_CLIENT", "SET_SELECTED_CLIENT_NAME"]),
            changeTab(e){
                this.currentTab = e;
            },
            changeClient(cId) {
              if(cId){
                this.SET_SELECTED_CLIENT(cId);
                this.SET_SELECTED_CLIENT_NAME(this.getClientsList.find(client => client.id === cId).name);
              }
            },
        }
    }
</script>
